// Misc
import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import size from 'lodash/size'
import some from 'lodash/some'

// Utils
import { createProposalDataFromTemplate } from 'utils/proposals'

// Constants
import proposalCreationTemplates from 'constants/proposalCreationTemplates'
import { MINDBODY } from 'constants/proposalFieldTypes'

// Actions
import connectActions from 'utils/connectActions'
import { createProposal } from 'actions/proposals'

// Selectors
import { connectGetters } from 'react-redux-getters'
import { getProposals } from 'selectors/proposals'
import { isMindbodyConnected } from 'selectors/integrations'

// Atoms
import { withUnlockFeatureDialog } from 'components/Billing/UnlockFeatureDialog'
import Hidden from '@material-ui/core/Hidden'
import { AppProgressActivator } from 'atoms/AppProgress'
import Expand from 'atoms/Expand'
import Button from 'atoms/Button'
import ItemsGrid from 'atoms/ItemsGrid'

// Icons
import AddIcon from '@material-ui/icons/Add'

const mapActionsToProps = {
  createProposalAction: createProposal
}

const mapGettersToProps = state => ({
  proposalsGetter: getProposals(state),
  isMindbodyConnectedGetter: isMindbodyConnected(state),
})

export default
@connectActions(mapActionsToProps)
@connectGetters(mapGettersToProps)
@withUnlockFeatureDialog()
class ProposalCreationButtons extends PureComponent {
  static propTypes = {
    createProposalAction: PropTypes.object.isRequired,
    proposalsGetter: PropTypes.object.isRequired,
    isMindbodyConnectedGetter: PropTypes.object.isRequired,
    activateProposals: PropTypes.bool,
    onCreate: PropTypes.func.isRequired,
    openUnlockFeatureDialog: PropTypes.func.isRequired,
  }

  state = {
    expanded: false
  }

  handleToggle = () => {
    const { expanded } = this.state
    this.setState({ expanded: !expanded })
  }

  handleButtonClick = creationTemplate => () => {
    this.setState({ expanded: false }, async () => {
      const {
        createProposalAction, proposalsGetter, onCreate, activateProposals, openUnlockFeatureDialog
      } = this.props
      const { requirePermission, ...template } = creationTemplate

      if (createProposalAction.isPending) return
      if (!proposalsGetter.isSucceded) return
      if (requirePermission && openUnlockFeatureDialog(requirePermission)) return

      const proposalsCount = size(proposalsGetter.data)
      const proposalData = createProposalDataFromTemplate(
        template,
        proposalsCount,
        !activateProposals
      )

      const proposal = await createProposalAction.run({
        params: [proposalData],
      })

      onCreate(proposal)
    })
  }

  renderButton = (creationTemplate, index) => {
    const { isMindbodyConnectedGetter } = this.props
    const isMindbodyButton = some(creationTemplate.data.fields, { type: MINDBODY })
    if (isMindbodyButton && !isMindbodyConnectedGetter.data) {
      return null
    }

    return (
      <Button
        key={index}
        icon={AddIcon}
        onClick={this.handleButtonClick(creationTemplate)}
      >
        { creationTemplate.name }
      </Button>
    )
  }

  renderButtons() {
    return (
      <ItemsGrid>
        { proposalCreationTemplates.map(this.renderButton) }
      </ItemsGrid>
    )
  }

  render() {
    const { createProposalAction } = this.props
    const { expanded } = this.state
    return (
      <Fragment>
        { createProposalAction.isPending && <AppProgressActivator /> }
        <Hidden xsDown>
          { this.renderButtons() }
        </Hidden>
        <Hidden smUp>
          <Expand
            expanded={expanded}
            onToggle={this.handleToggle}
            lebel="Select a call-to-action template and edit it below (add as many as you\'d like)"
          >
            { this.renderButtons() }
          </Expand>
        </Hidden>
      </Fragment>
    )
  }
}
